import React from "react";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import SystemErrorMessage from "../../../../../components/SystemErrorMessage";
import AuthService from "../../../../../services/AuthService";
import MembersApi from "../../../../../services/portal-api/MembersApi";
import withAuth from "../../../../../services/withAuth";


class MemberStats extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: {},
            error: "",
        };
    }

    componentDidMount() {
        if (this.props.member.shouldShowStats) {
            MembersApi.getUserStats((result) => {
                if (result.json.success) {
                    const { data } = this.state;
                    data["abs"] = result.json.r.ABS != undefined ? result.json.r.ABS : '0';
                    data["acs"] = result.json.r.ACS != undefined ? '$' + result.json.r.ACS : '$0';
                    data["top_selling_item"] = result.json.r.Top_Selling_Item != undefined ? result.json.r.Top_Selling_Item : 'None';
                    data["total_items"] = result.json.r.Total_Items != undefined ? result.json.r.Total_Items : '0';
                    data["total_sales"] = result.json.r.Total_Sales != undefined ? '$' + result.json.r.Total_Sales : '$0';
                    data["total_transactions"] = result.json.r.Total_Transactions != undefined ? result.json.r.Total_Transactions : '0';
                    this.setState({ data: data, isLoading: false }, () => { console.log(this.state.data) });
                } else {
                    const { data } = this.state;
                    data["abs"] = '0';
                    data["acs"] = '$0';
                    data["top_selling_item"] = 'None';
                    data["total_items"] = '0';
                    data["total_sales"] = '$0';
                    data["total_transactions"] = '0';
                    if (AuthService.getAdminType() == 1) {
                        this.setState({ data: data, error: "Unable to fetch Member Stats due to connection error. Please try again later. Reason: " + result.json.error, isLoading: false });
                    } else {
                        this.setState({ data: data, error: "Unable to fetch Member Stats due to connection error. Please try again later", isLoading: false });
                    }
                }
            }, this.props.member.futuraCustomerId);
        } else {
            const { data } = this.state;
            data["abs"] = '0';
            data["acs"] = '$0';
            data["top_selling_item"] = "None";
            data["total_items"] = '0';
            data["total_sales"] = '$0';
            data["total_transactions"] = '0';
            this.setState({ data: data, isLoading: false }, () => { console.log(this.state.data) });
        }
    }

    render() {
        let offset = { paddingLeft: 180 };
        return (
            AuthService.can('member stats') &&
            <div className="margin--30--bot relative">
                <h3 className="sub-title margin--10--bot">Member Stats</h3>
                {this.state.error && <SystemErrorMessage message={this.state.error} notified={false} />}
                <ul className="list--box list--info loading--inline">
                    <li>
                        <p className="list--info__label" style={offset}><strong
                            className="text--caps text--color">Total Transactions</strong> <span
                                className="text--break">{this.state.data.total_transactions}</span></p>
                        <p className="list--info__label" style={offset}><strong
                            className="text--caps text--color">Total Items</strong> <span
                                className="text--break">{this.state.data.total_items}</span></p>
                        <p className="list--info__label" style={offset}><strong
                            className="text--caps text--color">Total Sales</strong> <span
                                className="text--break">{this.state.data.total_sales}</span></p>
                        <p className="list--info__label" style={offset}><strong
                            className="text--caps text--color">Top Selling Item</strong> <span
                                className="text--break">{this.state.data.top_selling_item}</span></p>
                        <p className="list--info__label" style={offset}><strong
                            className="text--caps text--color">Avg Customer Spend</strong> <span
                                className="text--break">{this.state.data.acs}</span></p>
                        <p className="list--info__label" style={offset}><strong
                            className="text--caps text--color">Avg Basket Size</strong> <span
                                className="text--break">{this.state.data.abs}</span></p>
                    </li>
                    {this.state.isLoading && <LoadingSpinner isVisible={true} />}
                </ul>
            </div>
        );
    }
}

export default withAuth(MemberStats);